//Country const
export const FETCH_ALL_COUNTRY = 'fetch_all_country';
export const FETCH_ALL_COUNTRY_SUCCESS = 'fetch_all_country_success';
export const EDIT_COUNTRY = 'edit_country';
export const DELETE_COUNTRY = 'delete_country';
export const CREATE_COUNTRY = 'create_country';
export const CREATE_COUNTRY_SUCCESS = 'create_country_success';
export const UPDATE_COUNTRY_SUCCESS = 'update_country_success';
export const UPDATE_COUNTRY = 'update_country';
export const DELETE_COUNTRY_SUCCESS = 'delete_country_success';

// country_lang consts
export const FETCH_ALL_CONTRY_LANG = 'fetch_all_country_lang';
export const FETCH_ALL_CONTRY_LANG_SUCCESS = 'fetch_all_country_lang_success';
export const EDIT_CONTRY_LANG = 'edit_country_lang';
export const DELETE_CONTRY_LANG = 'delete_country_lang';
export const CREATE_CONTRY_LANG = 'create_country_lang';
export const CREATE_CONTRY_LANG_SUCCESS = 'create_country_lang_success';
export const UPDATE_CONTRY_LANG_SUCCESS = 'update_country_lang_success';
export const UPDATE_CONTRY_LANG = 'update_country_lang';
export const DELETE_CONTRY_LANG_SUCCESS = 'delete_country_lang_success';

// speciality
export const FETCH_ALL_SPECIALITY = 'fetch_all_speciality';
export const FETCH_ALL_SPECIALITY_SUCCESS = 'fetch_all_speciality_success';
export const EDIT_SPECIALITY = 'edit_speciality';
export const DELETE_SPECIALITY = 'delete_speciality';
export const CREATE_SPECIALITY = 'create_speciality';
export const CREATE_SPECIALITY_SUCCESS = 'create_speciality_success';
export const UPDATE_SPECIALITY_SUCCESS = 'update_speciality_success';
export const UPDATE_SPECIALITY = 'update_speciality';
export const DELETE_SPECIALITY_SUCCESS = 'delete_speciality_success';

//content types 
export const FETCH_ALL_CONTENT_TYPES = 'fetch_all_content_types';
export const FETCH_ALL_CONTENT_TYPES_SUCCESS = 'fetch_all_content_types_success';

//content types 
export const FETCH_ALL_HEALTH_PARTNER_TYPES = 'fetch_all_health_partner_types';
export const FETCH_ALL_HEALTH_PARTNER_TYPES_SUCCESS = 'fetch_all_health_partner_types_success';

//ROLES
export const FETCH_ALL_ROLES_SUCCESS = 'fetch_all_roles_successs';
export const FETCH_ALL_ROLES = 'fetch_all_roles';

//feature types 
export const FETCH_ALL_FEATURE_TYPES = 'fetch_all_feature_types';
export const FETCH_ALL_FEATURE_TYPES_SUCCESS = 'fetch_all_feature_types_successs';

// lang consts
export const FETCH_ALL_LANG = 'fetch_all_lang';
export const FETCH_ALL_LANG_SUCCESS = 'fetch_all_lang_success';
export const EDIT_LANG = 'edit_lang';
export const DELETE_LANG = 'delete_lang';
export const CREATE_LANG = 'create_lang';
export const CREATE_LANG_SUCCESS = 'create_lang_success';
export const UPDATE_LANG_SUCCESS = 'update_lang_success';
export const UPDATE_LANG = 'update_lang';
export const DELETE_LANG_SUCCESS = 'delete_lang_success';



// config consts
export const FETCH_REPORT_CONFIG = 'fetch_report_config';
export const FETCH_REPORT_CONFIG_SUCCESS = 'fetch_report_config_success';
export const UPDATE_REPORT_CONFIG = 'update_report_config';
export const UPDATE_REPORT_CONFIG_SUCCESS = 'update_report_config_success';
export const CREATE_DOCTOR_REPORTS = 'doctor_reports';
export const CREATE_DOCTOR_REPORTS_SUCCESS = 'create_doctor_reports_success';
export const VIEW_DOCTOR_REPORTS = 'view_doctor_reports';
export const VIEW_DOCTOR_REPORTS_SUCCESS = 'view_doctor_reports_success';
export const VIEW_DOCTOR_REPORTS_CLEAN = 'view_doctor_reports_clean';

